import React from "react";
import SubmittedAgreement from "../sumitted_agreement/SubmittedAgreement";

const ReconsiderationUnauthorizedAgreement = () => {
  const fileStatus = 35;
  const applicationPath = {
    copyright: "/admin/reconsideration-unauthorized-copyright",
    agreement: "/admin/reconsideration-unauthorized-agreement",
  };
  return (
    <SubmittedAgreement
      pageTitle={"অননুমোদন পুনর্বিবেচনা"}
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={"/admin/reconsideration-agreement-details"}
    />
  );
};

export default ReconsiderationUnauthorizedAgreement;
